import { StateDTO } from "../dto/StateDTO";
import { AmericanState } from "../models/AmericanState";

export const americanStateMapper = (dto: StateDTO): AmericanState => {
  return new AmericanState({
    id: dto.stateId,
    name: dto.stateName,
    code: dto.abbrev,
  });
};
